import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ErrorHelper from 'services/ErrorHelper';

import { Wrapper, StepBlock, StepItem } from './styled';

const FormStepper = ({
  steps,
  completedSteps = [],
  errors,
  variant,
  onClick,
  step: currentStep,
}) => {
  const { pathname } = useLocation();

  const errorHelper = useMemo(() => {
    return new ErrorHelper(variant);
  }, [variant]);

  const arraySteps = useMemo(() => {
    const arr = [];
    Object.keys(steps).forEach((key) => {
      arr.push(key);
    });
    return arr;
  }, [steps]);

  if (
    !pathname.includes('dishes/create') &&
    !pathname.includes('categories/create') &&
    !pathname.includes('special-menu/create')
    // !pathname.includes('options/create')
  ) {
    return null;
  }

  const failedSteps = errorHelper.getInvalidSteps(errors);

  return (
    <Wrapper>
      <StepBlock>
        {arraySteps.map((step, index) => {
          const isCompleted = completedSteps.includes(step);
          return (
            <StepItem
              role='presentation'
              onClick={() => onClick && isCompleted && onClick(step)}
              isFailed={failedSteps?.includes(step)}
              key={step}
              isCompleted={isCompleted}
              // isActive={isCompleted}
              isActive={step === currentStep}
            />
          );
        })}
      </StepBlock>
    </Wrapper>
  );
};

FormStepper.propTypes = {
  steps: PropTypes.shape({}),
  completedSteps: PropTypes.array,
  onClick: PropTypes.func,
  errors: PropTypes.any,
  variant: PropTypes.any,
};

export default FormStepper;
